import React from 'react';

import navArrow from '@/images/Header/nav-arrow.svg';

import { Links } from '@/utils/constants';
import { convertToNormal, RemoveSpaces } from '@/utils/functions';
import * as styled from './Breadcrumbs.styled';

interface IBreadcrumbs {
  $hideOnLg?: boolean;
  links: (Links | string)[];
}

export const Breadcrumbs: React.FC<IBreadcrumbs> = ({ $hideOnLg, links }) => {
  const navLinks = links.map((link) => {
    if (Object.values(Links).includes(link as Links)) {
      /* eslint-disable no-param-reassign */
      link = link.slice(1);
      link = convertToNormal(link);
      /* eslint-enable */
    }
    return {
      text: link,
      to: `/${RemoveSpaces(link)}`,
    };
  });
  const lastElement = navLinks[links.length - 1];
  navLinks.pop();

  return (
    <styled.NavBar
      $hideOnLg={$hideOnLg}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      <styled.NavItem
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
      >
        <styled.NavLink to={Links.HOME} itemProp="item">
          <styled.NavText itemProp="name">Home</styled.NavText>
        </styled.NavLink>
        <meta itemProp="position" content="1" />
        <styled.NavArrow src={navArrow} />
      </styled.NavItem>
      {navLinks?.map((link, index) => (
        <styled.NavItem
          key={link.text}
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <styled.NavLink to={link.to} key={link.text} itemProp="item">
            <styled.NavText itemProp="name"> {link.text}</styled.NavText>
          </styled.NavLink>
          <meta itemProp="position" content={`${index + 2}`} />
          <styled.NavArrow src={navArrow} />
        </styled.NavItem>
      ))}
      <styled.NavItem
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
      >
        <styled.NavText itemProp="name">{lastElement.text}</styled.NavText>
        <meta itemProp="position" content={`${navLinks.length + 2}`} />
      </styled.NavItem>
    </styled.NavBar>
  );
};
